<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#general" @click="activeComponent='tabGeneral'" ><i class="fa-solid fa-file-lines"></i> General</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#geos" @click="activeComponent='tabGeo'"><i class="fa-solid fa-earth-europe"></i>GEO</a></li>
        <li><a class="nav-link" data-toggle="tab" href="#tasks" @click="activeComponent='tabAfflinks'" ><i class="fas fa-tasks"></i> Aff Links</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row">
            <component :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TabGeneral from './Tabs/General'
import TabAfflinks from './Tabs/Afflinks'
import TabGeo from './Tabs/Geo'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      activeComponent: 'tabGeneral'
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand'
    })
  },
  components: {
    tabGeo: TabGeo,
    tabAfflinks: TabAfflinks,
    tabGeneral: TabGeneral
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brand/Content.vue